"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
/** Actions */
exports.battle = {
    actionType: types_1.ActionTiles.Battle,
    type: types_1.TileTypes.Action
};
exports.move = {
    actionType: types_1.ActionTiles.Move,
    type: types_1.TileTypes.Action
};
exports.pushBack = {
    actionType: types_1.ActionTiles.PushBack,
    type: types_1.TileTypes.Action
};
exports.sniper = {
    actionType: types_1.ActionTiles.Sniper,
    type: types_1.TileTypes.Action
};
exports.castling = {
    actionType: types_1.ActionTiles.Castling,
    type: types_1.TileTypes.Action
};
exports.rotation = {
    actionType: types_1.ActionTiles.Rotation,
    type: types_1.TileTypes.Action
};
exports.terror = {
    actionType: types_1.ActionTiles.Terror,
    type: types_1.TileTypes.Action
};
